"use client"

import { BookMarked } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookMarkedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookMarkedIcon = component(Icon)({ as: BookMarked })
